import { render, staticRenderFns } from "./Category.vue?vue&type=template&id=c352b2bc&"
import script from "./Category.vue?vue&type=script&lang=js&"
export * from "./Category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Projects\\Markomat-Client\\botaliberec-shop\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c352b2bc')) {
      api.createRecord('c352b2bc', component.options)
    } else {
      api.reload('c352b2bc', component.options)
    }
    module.hot.accept("./Category.vue?vue&type=template&id=c352b2bc&", function () {
      api.rerender('c352b2bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Category.vue"
export default component.exports